import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import GenericBaseResponseDTO from '../models/validation/GenericBaseResponseDTO';
import ExcelRowValidationResultDTO from '../models/validation/ExcelRowValidationResultDTO';
import SyncMatchmakerDataLogDTO from '../models/matchmaker/SyncMatchmakerDataLogDTO';
import TableResponseDTO from '../models/datatable/TableResponseDTO';
import AdminReportRequestDTO from '../models/report/AdminReportRequestDTO';
import TableRequestDTO from '../models/datatable/TableRequestDTO';

export class MatchmakerApiController {
    // post: Matchmaker/GetUserDetails
    public RouteGetUserDetails = () => `Matchmaker/GetUserDetails`;
    public getUserDetails(request: AdminReportRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<GenericBaseResponseDTO<string>>> {
        let url = this.RouteGetUserDetails();
        return HttpApi.RestRequest<any, GenericBaseResponseDTO<string>>(request, 'post', url, requestOptions);
    }
    // post: Matchmaker/MatchmakerDataUpload
    public RouteMatchmakerDataUpload = () => `Matchmaker/MatchmakerDataUpload`;
    public matchmakerDataUpload(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<GenericBaseResponseDTO<ExcelRowValidationResultDTO[]>>> {
        let url = this.RouteMatchmakerDataUpload();
        return HttpApi.RestRequest<any, GenericBaseResponseDTO<ExcelRowValidationResultDTO[]>>(null, 'post', url, requestOptions);
    }
    // post: Matchmaker/GetSyncMatchmakerDataLogTableData
    public RouteGetSyncMatchmakerDataLogTableData = () => `Matchmaker/GetSyncMatchmakerDataLogTableData`;
    public getSyncMatchmakerDataLogTableData(tableRequest: TableRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<SyncMatchmakerDataLogDTO>>> {
        let url = this.RouteGetSyncMatchmakerDataLogTableData();
        return HttpApi.RestRequest<any, TableResponseDTO<SyncMatchmakerDataLogDTO>>(tableRequest, 'post', url, requestOptions);
    }
}
var service = new MatchmakerApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/MatchmakerApiController.ts